import { combineReducers } from 'redux'
import usersReducer from './users/reducers'
import auditTrailReducer from './auditTrail/reducers'
import organizationReducer from './organization/reducers'
import { OrgSettingsState } from './types'

export default combineReducers<OrgSettingsState>({
	users: usersReducer,
	auditTrail: auditTrailReducer,
	organization: organizationReducer,
})
